import api from 'api'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

export const importarBeneficiariosBolsaFamilia = (
  formData: FormData,
  config: AxiosRequestConfig
): Promise<AxiosResponse> => {
  return api.bolsaFamilia.importar(formData, config)
}
